/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_FIELD_DATA, FIELD_DATA_RECEIVED } = constants.FieldOverviewConstants;

export default {
  REQUEST_FIELD_DATA,
  FIELD_DATA_RECEIVED,

  requestFieldTaskCount: payload => ({
    type: REQUEST_FIELD_DATA,
    payload
  }),
  fieldTaskCountReceived: () => ({
    type: FIELD_DATA_RECEIVED
  })
};
